import React, { useState } from "react";
import { Button, Upload, message } from "antd";
import styles from "./style.module.scss";
import { SaveOutlined, UploadOutlined } from "@ant-design/icons";

const FileImport = (props) => {

    const {handleUpload, uploading, fileList, setFileList} = props;
    const uploadProps = {
        beforeUpload: (file) => {
          const isCsv = file.type === 'text/csv';
          if (!isCsv) {
            message.error('You can only upload CSV files!');
          } else {
            setFileList([file]);
          }
          return false; // Prevent automatic upload
        },
        onRemove: () => {
          setFileList([]);
        },
        fileList,
      };
    return <>
    <div>
      <Upload {...uploadProps}>
        <div className={styles.menu_upload}>
            <div className={styles.upload_img_center}>
                <div style={{ alignItems: 'center'}}><img src="/images/upload.png" alt="FoodLuv" /></div>
                <div>Click or drag file to this area to upload</div>
            </div>
        </div>
      </Upload>
      <div className="mt-1">
        Do you want sample template? <a href="/menu_item_template.csv" download="menu_item_template.csv">Download</a>
      </div>
      <Button
        type="primary"
        onClick={handleUpload}
        disabled={fileList.length === 0}
        loading={uploading}
        style={{ marginTop: 16, display:'flex', marginLeft: "auto" , alignItems:"center"}}
        icon={<SaveOutlined />}
      >
        {uploading ? 'Uploading' : 'Upload'}
      </Button>
    </div>
    </>
};
export default FileImport;
